<template>
  <el-dialog title="统一快捷配置" :visible.sync="visible" width="min(720px, 94vw)" top="5vh" append-to-body :close-on-click-modal="false" custom-class="quick-company-scope">
    <el-steps :active="step" finish-status="success" simple>
      <el-step title="选择公司" /><el-step title="选择品牌" /><el-step title="设置区域" />
    </el-steps>
    <div class="quick-body">
      <template v-if="step === 0">
        <label class="quick-label">公司（可多选）</label>
        <el-input v-model="search" size="small" placeholder="搜索公司名称或编号" prefix-icon="el-icon-search" clearable />
        <div class="quick-tools"><span>已选 {{ companyIds.length }} 家</span><el-button type="text" @click="selectCompanies">全选</el-button><el-button type="text" :disabled="!companyIds.length" @click="companyIds = []">清空</el-button></div>
        <el-checkbox-group v-model="companyIds" class="quick-options">
          <el-checkbox v-for="company in filteredCompanies" :key="company.companyId" :label="company.companyId">{{ company.companyName }}</el-checkbox>
        </el-checkbox-group>
        <p v-if="!filteredCompanies.length" class="quick-empty">暂无匹配公司</p>
      </template>
      <template v-else-if="step === 1">
        <label class="quick-label">品牌（可多选）</label>
        <p class="quick-note">为 {{ companyIds.length }} 家公司统一配置，仅展示所选公司共有的品牌。</p>
        <el-input v-model="search" size="small" placeholder="搜索品牌" prefix-icon="el-icon-search" clearable />
        <div class="quick-tools"><span>已选 {{ brandIds.length }} 个</span><el-button type="text" @click="selectBrands">全选</el-button><el-button type="text" :disabled="!brandIds.length" @click="brandIds = []">清空</el-button></div>
        <el-checkbox-group v-model="brandIds" class="quick-options">
          <el-checkbox v-for="brand in filteredBrands" :key="brand.brandId" :label="brand.brandId">{{ brand.brandName }}</el-checkbox>
        </el-checkbox-group>
        <p v-if="!filteredBrands.length" class="quick-empty">{{ commonBrands.length ? '暂无匹配品牌' : '所选公司没有共同品牌，请返回调整公司' }}</p>
      </template>
      <template v-else>
        <label class="quick-label">统一区域</label>
        <BrandRegionEditor :value="region" @input="region = $event" />
        <div class="quick-preview">
          <strong>{{ companyIds.length }} 家公司 · {{ brandIds.length }} 个品牌 · {{ region.allRegions ? '全国' : region.regions.length + ' 个地区' }}</strong>
          <p>公司：{{ selectedCompanies.map(company => company.companyName).join('、') }}</p>
          <p>品牌：{{ selectedBrands.map(brand => brand.brandName).join('、') }}</p>
          <p>应用将覆盖全部已有范围，仅保留本次选择的公司、品牌及区域。应用后请点击「保存配置」生效。</p>
        </div>
      </template>
    </div>
    <div slot="footer" class="quick-footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button v-if="step > 0" size="small" @click="go(-1)">上一步</el-button>
      <el-button v-if="step < 2" type="primary" size="small" :disabled="step === 0 ? !companyIds.length : !brandIds.length" @click="go(1)">下一步</el-button>
      <el-button v-else type="primary" size="small" :disabled="!region.allRegions && !region.regions.length" @click="apply">应用到当前配置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BrandRegionEditor from './BrandRegionEditor.vue';
export default {
  name: 'QuickCompanyScope',
  components: { BrandRegionEditor },
  props: { companies: { type: Array, required: true } },
  data() { return { visible: false, step: 0, search: '', companyIds: [], brandIds: [], region: { allRegions: false, regions: [] } }; },
  computed: {
    availableCompanies() { return this.companies.filter(company => !company.unavailable); },
    filteredCompanies() { const query = this.search.trim().toLowerCase(); return this.availableCompanies.filter(company => (company.companyName + company.companyId).toLowerCase().includes(query)); },
    selectedCompanies() { return this.availableCompanies.filter(company => this.companyIds.includes(company.companyId)); },
    commonBrands() {
      if (!this.selectedCompanies.length) return [];
      return this.selectedCompanies[0].brands.filter(brand => this.selectedCompanies.every(company => company.brands.some(item => item.brandId === brand.brandId)));
    },
    filteredBrands() { return this.commonBrands.filter(brand => brand.brandName.toLowerCase().includes(this.search.trim().toLowerCase())); },
    selectedBrands() { return this.commonBrands.filter(brand => this.brandIds.includes(brand.brandId)); },
  },
  methods: {
    open(config) {
      this.step = 0; this.search = ''; this.brandIds = []; this.region = { allRegions: false, regions: [] };
      this.companyIds = config.companies.filter(company => this.availableCompanies.some(item => item.companyId === company.companyId)).map(company => company.companyId);
      this.visible = true;
    },
    selectCompanies() { this.companyIds = [...new Set([...this.companyIds, ...this.filteredCompanies.map(company => company.companyId)])]; },
    selectBrands() { this.brandIds = [...new Set([...this.brandIds, ...this.filteredBrands.map(brand => brand.brandId)])]; },
    go(direction) {
      if (direction > 0 && ((this.step === 0 && !this.companyIds.length) || (this.step === 1 && !this.brandIds.length))) return;
      this.brandIds = this.brandIds.filter(id => this.commonBrands.some(brand => brand.brandId === id));
      this.step += direction; this.search = '';
    },
    apply() {
      if (!this.selectedCompanies.length || !this.selectedBrands.length || (!this.region.allRegions && !this.region.regions.length)) return;
      // 每个公司/品牌分别复制地区路径，避免后续逐项编辑时相互联动。
      const companies = this.selectedCompanies.map(company => ({
        companyId: company.companyId, allBrands: false, brands: this.selectedBrands.map(brand => brand.brandId),
        brandRegions: this.region.allRegions ? [] : this.selectedBrands.map(brand => ({ brandId: brand.brandId, allRegions: false, regions: JSON.parse(JSON.stringify(this.region.regions)) })),
      }));
      this.$emit('apply', companies); this.visible = false;
    },
  },
};
</script>

<style scoped>
.quick-body { min-height: 300px; padding-top: 20px; }
.quick-label { display: block; margin-bottom: 10px; color: #303133; font-weight: 600; }
.quick-note, .quick-preview p { font-size: 12px; line-height: 20px; color: #73767a; margin: 0 0 10px; }
.quick-tools { display: flex; align-items: center; gap: 16px; min-height: 40px; font-size: 12px; color: #73767a; }
.quick-tools .el-button + .el-button { margin-left: 0; }
.quick-options { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 16px; max-height: 300px; overflow-y: auto; padding: 4px 0; }
.quick-options .el-checkbox { margin: 0; display: flex; align-items: baseline; min-width: 0; }
.quick-options ::v-deep .el-checkbox__label { white-space: normal; overflow-wrap: anywhere; }
.quick-empty { text-align: center; padding: 24px 0; color: #909399; }
.quick-preview { background: #f5f7fa; padding: 12px; border-radius: 4px; margin-top: 12px; }
.quick-preview strong { display: block; margin-bottom: 8px; color: #303133; }
.quick-preview p:last-child { margin-bottom: 0; }
.quick-footer { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 10px; }
.quick-footer .el-button + .el-button { margin-left: 0; }
@media (max-width: 620px) { .quick-options { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>

<style>
.quick-company-scope.el-dialog { display: flex; flex-direction: column; max-height: 90vh; margin-bottom: 5vh; }
.quick-company-scope > .el-dialog__header, .quick-company-scope > .el-dialog__footer { flex-shrink: 0; }
.quick-company-scope > .el-dialog__body { min-height: 0; overflow-y: auto; }
</style>
